import { render } from "./SessionExpiredModalComp.vue?vue&type=template&id=0bfe574c&scoped=true"
import script from "./SessionExpiredModalComp.vue?vue&type=script&lang=js"
export * from "./SessionExpiredModalComp.vue?vue&type=script&lang=js"

import "./SessionExpiredModalComp.vue?vue&type=style&index=0&id=0bfe574c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfe574c"]])

export default __exports__